import vue from '@/main'

import user from "@/http/requests/user"

import store from "@/store/store.js"

export default {
  fetch({ commit }) {
    return new Promise((resolve, reject) => {
      user.fetch().then(response => {
        commit('SET_USERS', response.data.data.users)
        resolve(response)
      })
      .catch((error) => { reject(error) })
    })
  },
  fetchPaginated({ commit }, searchParams) {
    return new Promise((resolve, reject) => {
      let concatResults = false
      let setInInternal = false

      if (searchParams.concatResults) {
        concatResults = searchParams.concatResults
        delete searchParams.concatResults
      }

      if (searchParams.setInInternal) {
        setInInternal = searchParams.setInInternal
        delete searchParams.setInInternal
      }

      searchParams.order_by = [
        'latest_message',
        'DESC'
      ]

      store.dispatch('setShowLoadingOverlay', false)
      user.fetchPaginated(searchParams).then(response => {
        commit('SET_PAGINATED_USER', {
          concatResults: concatResults,
          setInInternal: setInInternal,
          users: response.data.data['paginatedUsers']['items'],
        })
        store.dispatch('setShowLoadingOverlay', true)
        resolve(response)
      }).catch((error) => {
        store.dispatch('setShowLoadingOverlay', true)
        reject(error)
      })
    })
  },
  add({ commit }, data) {
    return new Promise((resolve, reject) => {
      user.add(data).then(response => {
        commit('ADD_USER', response.data.data.newUser.user)
        resolve(response)
      })
      .catch((error) => { reject(error) })
    })
  },
  update({ commit }, data) {
    return new Promise((resolve, reject) => {
      user.update(data).then(response => {
        commit('UPDATE_USER', response.data.data.updateUser.user)
        resolve(response)
      })
      .catch((error) => { reject(error) })
    })
  },
  delete({ commit }, userId) {
    return new Promise((resolve, reject) => {
      user.delete(userId).then(response => {
        commit('DELETE_USER', userId)
        resolve(response)
      })
      .catch((error) => { reject(error) })
    })
  },
  infos() {
    return new Promise((resolve, reject) => {
      user.infos().then(response => {
        store.commit('UPDATE_USER_INFO', response.data.data.userInfos)
        resolve(response)
      })
      .catch((error) => { reject(error) })
    })
  },
  backToOriginalUser(originalUser) {
    return new Promise((resolve) => {
      store.commit("auth/SET_BEARER", originalUser.originalBearer)
      store.commit('UPDATE_USER_INFO', originalUser)

      vue.$router.push({ path: '/' })

      resolve(originalUser)
    })
  },
  updatePassword({ commit }, data) {
    return new Promise((resolve, reject) => {
      user.updatePassword(data).then(response => {
        store.commit("auth/SET_BEARER", response.data.data.updateUserPassword.token)
        commit('UPDATE_USER', response.data.data.updateUserPassword.user)
        resolve(response)
      })
      .catch((error) => { reject(error) })
    })
  },
  fetchInstances(_, userId) {
    return new Promise((resolve, reject) => {
      user.fetchInstances(userId).then(response => {
        resolve(response)
      })
      .catch((error) => { reject(error) })
    })
  },
  deleteInstance(_, userInstanceId) {
    return new Promise((resolve, reject) => {
      user.deleteInstance(userInstanceId).then(response => {
        resolve(response)
      })
      .catch((error) => { reject(error) })
    })
  },
  fetchDiffInstances(_, removeIds = []) {
    return new Promise((resolve, reject) => {
      user.fetchDiffInstances(removeIds).then(response => {
        resolve(response)
      })
      .catch((error) => { reject(error) })
    })
  },
  twoFactorActivity(_, data) {
    return new Promise((resolve, reject) => {
      user.twoFactorActivity(data).then(response => {
        resolve(response)
      })
      .catch((error) => { reject(error) })
    })
  },
  getUserValidateTwoFatctor(_, verifyActivity) {
    return new Promise((resolve, reject) => {
      user.getUserValidateTwoFatctor(verifyActivity).then(response => {
        resolve(response)
      })
      .catch((error) => { reject(error) })
    })
  },
  generateQrcode(_, verifyActivity) {
    return new Promise((resolve, reject) => {
      user.generateQrcode(verifyActivity).then(response => {
        resolve(response)
      })
      .catch((error) => { reject(error) })
    })
  },
  setUnseenMessages({commit}, {userId, increments = false}) {
    return new Promise((resolve) => {
      commit('SET_UNSEEN_MESSAGES', {userId, increments})
      resolve()
    });
  },
}
